import { Task, TaskStatus, ACTIVE_TASK_STATUSES } from 'modules/Tasks/types';
import collectiveApi from 'modules/common/collectiveApi';

export interface GetMemberTasksParams {
    location?: string;
    /** Only tasks not attached to any group (top-level feed). Mutually exclusive with groupId. */
    ungrouped?: boolean;
    /** Only tasks belonging to this group (drill-in). Mutually exclusive with ungrouped. */
    groupId?: string;
    /** Defaults to ACTIVE_TASK_STATUSES. */
    statuses?: readonly TaskStatus[];
    /** Narrow to specific task types server-side, e.g. ['eoy_financials_review']. */
    taskTemplateNames?: readonly string[];
}

export default async function getMemberTasks({
    location,
    ungrouped,
    groupId,
    statuses = ACTIVE_TASK_STATUSES,
    taskTemplateNames,
}: GetMemberTasksParams = {}): Promise<Task[]> {
    const { data } = await collectiveApi.get<Task[]>('/v2/members/tasks/', {
        params: {
            is_member_task: true,
            statuses: statuses.join(','),
            ...(location !== undefined && { location }),
            ...(ungrouped && { ungrouped: true }),
            ...(groupId !== undefined && { group_id: groupId }),
            ...(taskTemplateNames?.length && { task_template_names: taskTemplateNames.join(',') }),
        },
    });
    return data;
}
